module.exports = __webpack_public_path__ + "img/category-protection.c5effc9d.png";